import { _decorator } from 'cc';
import HSL from '../../CCClass/HSL';
import HSLAdjuster from '../Shader/HSLAdjuster';
import MultiThemeComponent from './MultiThemeComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('MultiThemeHSL')
@menu('MultiTheme/MultiThemeHSL')
@requireComponent(HSLAdjuster)
export default class MultiThemeHSL extends MultiThemeComponent<HSLAdjuster> {
    @property([HSL])
    private readonly hsl: HSL[] = [];

    public getMaxTheme(): number {
        return this.hsl.length;
    }

    public updateHSLs(colors: HSL[]) {
        this.hsl.length = 0;
        this.hsl.push(...colors);
        this.onThemeChanged();
    }

    protected getTarget() {
        return this.getComponent(HSLAdjuster);
    }

    protected onThemeChanged() {
        if (!this.hsl[this._theme]) {
            return;
        }
        const { hue, saturation, lightness } = this.hsl[this._theme];
        this.target.hue = hue;
        this.target.saturation = saturation;
        this.target.lightness = lightness;
    }
}
